var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3974_61966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1673 6.66683V15.0002C19.1673 15.9168 18.4173 16.6668 17.5006 16.6668H4.16732C3.70898 16.6668 3.33398 16.2918 3.33398 15.8335C3.33398 15.3752 3.70898 15.0002 4.16732 15.0002H17.5006V6.66683C17.5006 6.2085 17.8756 5.8335 18.334 5.8335C18.7923 5.8335 19.1673 6.2085 19.1673 6.66683ZM3.33398 13.3335C1.95065 13.3335 0.833984 12.2168 0.833984 10.8335V5.8335C0.833984 4.45016 1.95065 3.3335 3.33398 3.3335H13.334C14.7173 3.3335 15.834 4.45016 15.834 5.8335V11.6668C15.834 12.5835 15.084 13.3335 14.1673 13.3335H3.33398ZM5.83398 8.3335C5.83398 9.71683 6.95065 10.8335 8.33398 10.8335C9.71732 10.8335 10.834 9.71683 10.834 8.3335C10.834 6.95016 9.71732 5.8335 8.33398 5.8335C6.95065 5.8335 5.83398 6.95016 5.83398 8.3335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3974_61966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryAdvance);
export default __webpack_public_path__ + "static/media/salary_advance.89b804f7b225901a26b2e1674f5d98dc.svg";
export { ForwardRef as ReactComponent };